if (!customElements.get('wlsn-product-section')) {
    class WLSNProductSection extends HTMLElement {
      constructor() {
        super();
  
        this.classes = {
          activeClass: 'is-active',
          visibleClass: 'is-visible',
          tabs: 'js-wlsn-product-section-tab',
          content: 'js-wlsn-product-section-content',
        };
  
        this.elements = {
          tabs: this.querySelectorAll(`.${this.classes.tabs}`),
          contents: this.querySelectorAll(`.${this.classes.content}`),
        };
      }
  
      connectedCallback() {
        if (!this.elements.tabs.length || !this.elements.contents.length) return;
  
        this.elements.tabs.forEach(tab => {
          tab.addEventListener('click', () => {
            const index = tab.dataset.index;
  
            this.elements.tabs.forEach(t =>
              t.classList.remove(this.classes.activeClass)
            );
  
            this.elements.contents.forEach(c =>
              c.classList.remove(this.classes.visibleClass)
            );
  
            tab.classList.add(this.classes.activeClass);
  
            const activeContent = this.querySelector(
              `.${this.classes.content}[data-index="${index}"]`
            );
  
            if (activeContent) {
              activeContent.classList.add(this.classes.visibleClass);
            }
          });
        });
      }
    }
  
    customElements.define('wlsn-product-section', WLSNProductSection);
  }
  